var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#heart_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M55.872 38.355a7.422 7.422 0 1 1-10.358 10.358l-2.762 2.761a1.06 1.06 0 0 1-1.499 0L26.95 37.171c-3.923-3.923-3.933-10.277-.03-14.212 3.973-3.942 10.33-3.932 14.252-.01l.83.83.83-.83c3.923-3.922 10.28-3.932 14.213-.03 3.944 3.975 3.933 10.33.01 14.253zm-13.869 10.87 2.498-2.498a7.422 7.422 0 0 1 9.386-9.386l1.67-1.67c3.104-3.104 3.105-8.138.02-11.224a7.953 7.953 0 0 0-11.244.001l-1.58 1.58a1.06 1.06 0 0 1-1.5 0l-1.58-1.58c-3.103-3.104-8.14-3.103-11.224-.02a7.95 7.95 0 0 0 .001 11.244zm9.542.461a5.301 5.301 0 1 0 0-10.602 5.301 5.301 0 0 0 0 10.602m-1.06-6.361v-1.06a1.06 1.06 0 0 1 2.12 0v1.06h1.06a1.06 1.06 0 1 1 0 2.12h-1.06v1.06a1.06 1.06 0 0 1-2.12 0v-1.06h-1.06a1.06 1.06 0 1 1 0-2.12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "heart_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35537",
    result: "shape"
  })))));
};
export default SvgHeart;